import { useEffect } from 'react';

import { LocalStore } from 'constants/localstore';
import { useAppDispatch, useAppSelector } from 'store/store-hooks';
import { setIsAuthenticated } from 'components/app/_mediator/app.slice';
import { useAppSignOut } from 'components/app/_mediator/use-app-sign-out';
import { App } from './app';

export const AppProtected = () => {
  const isAuthenticated = useAppSelector((state) => state.app.isAuthenticated);
  const dispatch = useAppDispatch();
  const signOut = useAppSignOut();

  useEffect(() => {
    const token = localStorage.getItem(LocalStore.token);
    if (!token) signOut();
    else dispatch(setIsAuthenticated(true));
  }, []);

  useEffect(() => {
    if (isAuthenticated === false) signOut();
  }, [isAuthenticated]);

  return isAuthenticated ? <App /> : null;
};
